import classNames from "classnames";
import { Button, Flex } from "@simplybusiness/mobius";
import { CardPopover } from "../../../../QuoteCards/QuoteCard/InfoModal/CardPopover";
import { type PaymentTermsOption } from "../../PaymentTermsChecklist";
import { CombinedPaymentButton } from "./CombinedPaymentButton";

export const CallToAction = ({
  enableCheckoutFormSubmission,
  isFormSubmitting,
  fireCheckoutButtonClickedEvent,
  onCallToActionClick,
  buttonText,
  poweredByStripeLogo,
  agreementOptions,
  eventTrackerCallback,
  legalAgreementButtonsNotCheckedCallback,
  checkedAgreements,
  setHasAttemptedSubmit,
}: CallToActionProps) => {
  const allAccepted = agreementOptions.every(opt =>
    checkedAgreements.includes(opt.value),
  );
  const handleCancelAnytimeClick = () => {
    eventTrackerCallback();
  };

  const handleCheckoutClick = (e: React.MouseEvent) => {
    setHasAttemptedSubmit(true);
    if (!allAccepted) {
      e.preventDefault();
      legalAgreementButtonsNotCheckedCallback();
      return;
    }
    fireCheckoutButtonClickedEvent();
  };

  const handlePayClick = () => {
    setHasAttemptedSubmit(true);
    if (!allAccepted) {
      legalAgreementButtonsNotCheckedCallback();
      return;
    }
    onCallToActionClick(true);
  };

  return (
    <div
      className={classNames("mobius-payment-summary__form-actions-box", {
        "combined-payment-page-sticky": !enableCheckoutFormSubmission,
      })}
    >
      <Flex
        data-testid="payment-cta-container"
        className="mobius-payment-cta-container-align-left mobius-payment-cta-container-align-center"
      >
        <div className="mobius-payment-cta__popover-wrapper">
          <CardPopover
            toggleText="Cancel anytime"
            body="You can easily cancel your insurance policy at any time during the policy period. Please note that penalties may apply."
            onOpen={handleCancelAnytimeClick}
          />
        </div>
        {enableCheckoutFormSubmission ? (
          <Button
            className="mobius-payment-summary__checkout-button"
            type="submit"
            size="md"
            isLoading={isFormSubmitting}
            isDisabled={isFormSubmitting}
            data-testid="submit-btn"
            onClick={handleCheckoutClick}
          >
            Checkout
          </Button>
        ) : (
          <CombinedPaymentButton
            buttonText={buttonText}
            poweredByStripeLogo={poweredByStripeLogo}
            onClick={handlePayClick}
          />
        )}
      </Flex>
    </div>
  );
};

export interface CallToActionProps {
  enableCheckoutFormSubmission: boolean;
  isFormSubmitting: boolean;
  fireCheckoutButtonClickedEvent: () => void;
  onCallToActionClick: (drawerOpen: boolean) => void;
  buttonText: string;
  poweredByStripeLogo: string;
  agreementOptions: PaymentTermsOption[];
  eventTrackerCallback: () => void;
  legalAgreementButtonsNotCheckedCallback: () => void;
  checkedAgreements: string[];
  setHasAttemptedSubmit: (value: boolean) => void;
}
